import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useState, Fragment } from 'react';
import { useMediaQuery } from '@mui/material';
import { StyledSearchAndFilter, SearchOrFilterIcon } from './searchAndFilterStyles';
import classnames from 'classnames';
import { useWindowSize } from '../../../utils/resizeHook';
import { EmbersSearch } from '../../../search/search';
import { EmbersTableSwitch } from '../../../switch/tableSwitch';
import { FiltersDecorator } from './filtersDecorator/filtersDecorator';
import { FilterTags } from './filtersDecorator/filtersTags';
import { useFilterTags } from './filtersDecorator/useFilterTags';
import { PROMETHEAN_BREAKPOINT_NAV_CHANGE } from '../../../styles/breakpoints/breakpoints';
export var SearchAndFilter = function SearchAndFilter(_ref) {
  var children = _ref.children,
    filterDecoratorProps = _ref.filterDecoratorProps,
    searchProps = _ref.searchProps,
    className = _ref.className,
    defaultMode = _ref.defaultMode,
    onModeChange = _ref.onModeChange;
  var mobileSearchAndFilterViewPort = useMediaQuery("(max-width:".concat(PROMETHEAN_BREAKPOINT_NAV_CHANGE, "px)"));
  var _useState = useState('search'),
    _useState2 = _slicedToArray(_useState, 2),
    mode = _useState2[0],
    setMode = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    hasResizedInSearchMode = _useState4[0],
    setResizedInSearchMode = _useState4[1];
  var size = useWindowSize();
  var updateResized = function updateResized() {
    if (mode === 'search') {
      setResizedInSearchMode(true);
    }
  };
  useEffect(function () {
    defaultMode && setMode(defaultMode);
  }, [defaultMode]);
  useEffect(function () {
    updateResized();
  }, [size]);
  var _useFilterTags = useFilterTags({
      onSearch: function onSearch(searchText) {
        var _searchProps$onSearch;
        searchProps === null || searchProps === void 0 || (_searchProps$onSearch = searchProps.onSearch) === null || _searchProps$onSearch === void 0 || _searchProps$onSearch.call(searchProps, searchText);
      },
      onFilterChange: function onFilterChange(params) {
        var _filterDecoratorProps;
        filterDecoratorProps === null || filterDecoratorProps === void 0 || (_filterDecoratorProps = filterDecoratorProps.onFilterChange) === null || _filterDecoratorProps === void 0 || _filterDecoratorProps.call(filterDecoratorProps, params.filterName, params.value, params.fromModal);
      },
      onTagRemove: function onTagRemove(filterName, code) {
        filterDecoratorProps === null || filterDecoratorProps === void 0 || filterDecoratorProps.onTagRemove(filterName, code);
      },
      onClearAll: function onClearAll() {
        filterDecoratorProps === null || filterDecoratorProps === void 0 || filterDecoratorProps.onClearAll();
      },
      onSave: function onSave(newFilterValue, newFilterItems) {
        var newSearchText = '';
        var searchFilterItem = newFilterItems.find(function (item) {
          return item.type === 'search';
        });
        if (searchFilterItem) {
          newSearchText = searchFilterItem.code;
        }
        filterDecoratorProps === null || filterDecoratorProps === void 0 || filterDecoratorProps.onSave(newFilterValue, newSearchText);
      },
      labelKey: filterDecoratorProps === null || filterDecoratorProps === void 0 ? void 0 : filterDecoratorProps.labelKey,
      codeKey: filterDecoratorProps === null || filterDecoratorProps === void 0 ? void 0 : filterDecoratorProps.codeKey,
      dateFormatString: filterDecoratorProps === null || filterDecoratorProps === void 0 ? void 0 : filterDecoratorProps.dateFormatString
    }),
    initFilterItems = _useFilterTags.initFilterItems,
    updateSearchTag = _useFilterTags.updateSearchTag,
    searchText = _useFilterTags.searchText,
    filterItems = _useFilterTags.filterItems,
    handleSearch = _useFilterTags.handleSearch,
    updateFilterTags = _useFilterTags.updateFilterTags,
    handleFilterChange = _useFilterTags.handleFilterChange,
    handleTagDelete = _useFilterTags.handleTagDelete,
    handleClearAll = _useFilterTags.handleClearAll,
    handleSave = _useFilterTags.handleSave;
  useEffect(function () {
    initFilterItems(searchProps === null || searchProps === void 0 ? void 0 : searchProps.defaultSearchText, filterDecoratorProps === null || filterDecoratorProps === void 0 ? void 0 : filterDecoratorProps.defaultFiltersValueMap);
  }, []);
  useEffect(function () {
    var _searchProps$defaultS;
    updateSearchTag((_searchProps$defaultS = searchProps === null || searchProps === void 0 ? void 0 : searchProps.defaultSearchText) !== null && _searchProps$defaultS !== void 0 ? _searchProps$defaultS : '');
  }, [searchProps === null || searchProps === void 0 ? void 0 : searchProps.defaultSearchText]);
  useEffect(function () {
    updateFilterTags(filterDecoratorProps === null || filterDecoratorProps === void 0 ? void 0 : filterDecoratorProps.defaultFiltersValueMap);
  }, [filterDecoratorProps === null || filterDecoratorProps === void 0 ? void 0 : filterDecoratorProps.defaultFiltersValueMap]);
  var isSwitchable = false;
  var tableSwitch;
  if (!mobileSearchAndFilterViewPort) {
    if (searchProps && filterDecoratorProps) {
      isSwitchable = true;
      tableSwitch = /*#__PURE__*/React.createElement(EmbersTableSwitch, {
        type: "filter",
        checked: mode === 'search',
        onChange: function onChange(e, checked) {
          var newMode = checked ? 'search' : 'filter';
          setMode(newMode);
          onModeChange === null || onModeChange === void 0 || onModeChange(newMode);
          if (hasResizedInSearchMode) {
            setTimeout(function () {
              return setResizedInSearchMode(false);
            });
          }
        }
      });
    } else if (filterDecoratorProps) {
      tableSwitch = /*#__PURE__*/React.createElement(SearchOrFilterIcon, {
        className: "SearchOrFilterIcon-filter"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon-filter"
      }));
    }
  }
  var searchComponent = searchProps ? /*#__PURE__*/React.createElement(EmbersSearch, _extends({}, searchProps, {
    className: classnames(searchProps.className, "".concat(isSwitchable && mode !== 'search' && filterDecoratorProps ? 'hidden' : '')),
    onSearch: handleSearch,
    defaultSearchText: searchText
  })) : /*#__PURE__*/React.createElement(Fragment, null);
  var filtersComponent = filterDecoratorProps ? /*#__PURE__*/React.createElement(FiltersDecorator, _extends({}, filterDecoratorProps, {
    className: classnames(filterDecoratorProps.className, "".concat(isSwitchable && mode !== 'filter' && searchProps ? 'hidden' : '')),
    reCalculateNeeded: hasResizedInSearchMode && mode === 'filter',
    isMobile: mobileSearchAndFilterViewPort,
    filterItems: filterItems,
    onFilterChange: handleFilterChange,
    onSave: handleSave
  }), children) : /*#__PURE__*/React.createElement(Fragment, null);
  return /*#__PURE__*/React.createElement(StyledSearchAndFilter, {
    className: classnames({
      'EmbersSearchAndFilter-root': !mobileSearchAndFilterViewPort,
      switchable: isSwitchable,
      'EmbersMobileSearchAndFilter-root': mobileSearchAndFilterViewPort
    }, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('EmbersSearchAndFilter-content', {
      'EmbersSearchAndFilter-content-searchAndFilter': searchProps && filterDecoratorProps
    })
  }, tableSwitch, searchComponent, filtersComponent), !mobileSearchAndFilterViewPort && filterDecoratorProps ? /*#__PURE__*/React.createElement(FilterTags, {
    showLabel: true,
    data: filterItems,
    onTagDelete: handleTagDelete,
    onClearAll: handleClearAll
  }) : /*#__PURE__*/React.createElement(React.Fragment, null));
};